var _path, _path2, _path3, _path4, _g, _path5, _path6, _g2, _path7, _path8, _g3, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPikkoNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 55,
    viewBox: "0 0 64 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13956_54921)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0942 39.9066L28.1692 38.7989C29.4322 19.7333 45.488 19.7724 48.6922 19.9741C49.1657 20.0039 49.4317 20.0412 49.4317 20.0412L50.3748 20.1679L50.3849 21.1199C50.3875 21.4655 50.3902 29.6595 44.5945 35.1962C40.8954 38.7337 35.7141 40.3366 29.1985 39.9703L28.0942 39.9066Z",
    fill: "url(#paint0_linear_13956_54921)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4308 41.2304L20.3262 41.2495C13.8121 41.3531 8.70127 39.5406 5.13442 35.8526C-0.449685 30.083 -0.149679 21.8833 -0.134484 21.5377L-0.0927337 20.5858L0.856077 20.497C0.856077 20.497 1.12298 20.4705 1.59382 20.4598C4.80244 20.3872 20.8305 20.9958 21.399 40.1192L21.4308 41.2304Z",
    fill: "url(#paint1_linear_13956_54921)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3553 90.529L34.5085 32.2616C34.3367 32.2671 34.1689 32.2839 33.9983 32.301L16.9672 34.01L22.8151 92.289L40.3553 90.529ZM18.4503 92.727L22.8151 92.289L16.9684 34.0216L16.8729 34.0312C9.8152 34.7394 4.20098 41.1564 4.40193 48.2835L5.28072 81.0623C5.46575 88.1763 11.3955 93.4349 18.4503 92.727ZM44.1126 90.152C51.1703 89.4438 55.9342 83.1121 54.7035 76.0883L49.0495 43.7917C47.8476 36.9385 41.362 31.8473 34.4969 32.2628L40.3437 90.5302L44.1126 90.152Z",
    fill: "#FFDE59"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13956_54921",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 3,
    width: 16,
    height: 31
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0234 3.24902L32.6741 3.13889L32.9565 33.5422L17.3058 33.6523L17.0234 3.24902Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13956_54921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5975 33.2034L23.8459 32.3873C19.4127 27.575 17.3467 22.5385 17.7046 17.4173C18.2641 9.39845 24.5572 4.17802 24.8264 3.96221L25.5627 3.35909L26.2612 4.01248C26.5158 4.24664 32.4574 9.8957 32.4975 17.9356C32.5237 23.0703 30.137 27.9507 25.4029 32.4418L24.5975 33.2034Z",
    fill: "url(#paint2_linear_13956_54921)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_13956_54921",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 26,
    width: 26,
    height: 26
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7188 29.0098L49.2629 26.7476L51.5394 49.434L28.9952 51.6962L26.7188 29.0098Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_13956_54921)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_13956_54921",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 27,
    width: 24,
    height: 24
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9987 27.8826C31.7711 28.5075 27.2359 34.09 27.8648 40.3569C28.4933 46.6208 34.0475 51.1939 40.2751 50.569C46.4998 49.9444 51.0375 44.3586 50.409 38.0947C49.7801 31.8279 44.2233 27.258 37.9987 27.8826Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_13956_54921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7266 29.0137L49.2707 26.7515L51.5472 49.4379L29.003 51.7001L26.7266 29.0137Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_13956_54921",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -2,
    y: 29,
    width: 26,
    height: 26
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.03125 31.7939L21.5129 29.5318L23.7894 52.2182L1.24518 54.4803L-1.03125 31.7939Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_13956_54921)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_13956_54921",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 30,
    width: 23,
    height: 24
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2487 30.6668C4.02109 31.2917 -0.514058 36.8742 0.11478 43.141C0.743326 49.405 6.29752 53.9781 12.5251 53.3532C18.7498 52.7286 23.2875 47.1428 22.659 40.8789C22.0301 34.612 16.4733 30.0422 10.2487 30.6668Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_13956_54921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.02344 31.7979L21.5207 29.5357L23.7972 52.2221L1.253 54.4842L-1.02344 31.7979Z",
    fill: "white"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4067 32.1333C34.522 32.5231 31.6928 36.0058 32.085 39.9149C32.477 43.8211 35.9418 46.6722 39.8265 46.2824C43.7082 45.8929 46.5375 42.4103 46.1455 38.504C45.7532 34.5949 42.2884 31.7438 38.4067 32.1333Z",
    fill: "#3D1F1E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6567 34.9175C6.77204 35.3073 3.94278 38.7899 4.33503 42.6991C4.727 46.6053 8.19182 49.4564 12.0765 49.0666C15.9582 48.6771 18.7875 45.1944 18.3955 41.2882C18.0032 37.3791 14.5384 34.528 10.6567 34.9175Z",
    fill: "#3D1F1E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3941 36.8948C39.247 35.4285 37.9445 34.3586 36.4849 34.505C35.0254 34.6515 33.9615 35.9589 34.1086 37.4251C34.2557 38.8914 35.5582 39.9614 37.0178 39.8149C38.4773 39.6684 39.5412 38.3611 39.3941 36.8948Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.73 39.2688C15.5829 37.8025 14.2804 36.7326 12.8209 36.879C11.3613 37.0255 10.2974 38.3329 10.4445 39.7992C10.5917 41.2654 11.8941 42.3354 13.3537 42.1889C14.8132 42.0425 15.8772 40.7351 15.73 39.2688Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9126 57.4841C28.2048 55.9703 21.2112 58.536 18.6327 60.1786C18.1187 60.506 17.8038 61.0502 17.7268 61.6547C17.3904 64.2961 17.7125 69.3866 24.6312 68.1024C33.1187 66.5269 36.657 68.2365 38.8335 63.3252C40.5747 59.3961 38.0581 57.8161 36.9126 57.4841Z",
    fill: "#3D1F1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13956_54921",
    x1: 39.9136,
    y1: 19.4214,
    x2: 38.5821,
    y2: 40.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13956_54921",
    x1: 10.378,
    y1: 20.261,
    x2: 10.8582,
    y2: 41.4697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13956_54921",
    x1: 25.5641,
    y1: 3.35914,
    x2: 24.5187,
    y2: 33.2006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13956_54921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPikkoNotification);
export default __webpack_public_path__ + "static/media/pikkoNotification.30a2318a1255ca98d1474c0cec67fc1f.svg";
export { ForwardRef as ReactComponent };